import React from "react";
import SimpleHammerIcon from "../../../../icons/SimpleHammerIcon";

interface BidderRankLabelProps {
  isHighestBidder: boolean;
}

export default function BidderRankLabel({
  isHighestBidder,
}: BidderRankLabelProps) {
  return (
    <div className="py-1">
      {isHighestBidder ? (
        <div className="bg-linear-green-fade py-2 px-2 sm:px-4 text-xs sm:text-sm flex items-center font-semibold gap-2 sm:gap-4 text-brand-textBlack relative rounded-sm">
          <SimpleHammerIcon />
          <span>Currently, you are the top bidder</span>
          <span className="text-brand-orange text-xs sm:text-sm ml-auto">
            My Rank: 1
          </span>
        </div>
      ) : (
        <div className="bg-linear-purple py-2 px-4 text-xs sm:text-sm flex items-center font-semibold gap-3 text-brand-textBlack rounded-sm">
          <SimpleHammerIcon />
          <span>Place a higher amount to be a top bidder</span>
        </div>
      )}
    </div>
  );
}
